import {matchPath} from 'react-router-dom'
import {analyticsParams,analyticsSearch} from './api'
export interface AnalyticsCrumb {label:string;to:string}
export function cohortAnalyticsRoot(clientId:string,cohortId:string){
  return `/admin/clients/${encodeURIComponent(clientId)}/cohorts/${encodeURIComponent(cohortId)}/analytics`
}
export function cohortAnalyticsContext(pathname:string){
  const match=matchPath('/admin/clients/:clientId/cohorts/:cohortId/analytics/*',pathname)
  return match?{clientId:match.params.clientId!,cohortId:match.params.cohortId!}:null
}
export function analyticsRoot(pathname:string){
  const cohort=cohortAnalyticsContext(pathname)
  return cohort?cohortAnalyticsRoot(cohort.clientId,cohort.cohortId):'/admin/analytics'
}
/** Nested routes always retain the cohort boundary, including direct links. */
export function analyticsRouteParams(pathname:string,search:URLSearchParams){
  const cohort=cohortAnalyticsContext(pathname)
  if(!cohort)return analyticsParams(search)
  const scoped=new URLSearchParams(search)
  scoped.set('clientId',cohort.clientId);scoped.delete('cohortIds');scoped.append('cohortIds',cohort.cohortId)
  scoped.set('scope','hr_preview');scoped.set('includeInternal','true');scoped.set('includeTrial','true')
  scoped.set('allStartDates','true')
  return analyticsParams(scoped)
}
/** Funnel lists return to their report; study periods use the student hierarchy. */
export function analyticsBreadcrumbs(pathname:string,search:string):AnalyticsCrumb[]{
  const root=analyticsRoot(pathname)
  if(pathname!==`${root}/students`&&pathname!==`${root}/periods`)return []
  const parsed=analyticsRouteParams(pathname,new URLSearchParams(search))
  const query=parsed.success?analyticsSearch(parsed.data):''
  return [{label:'Analytics',to:`${root}${query?`?${query}`:''}`}]
}
